import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationStackedAreaChartIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0)", children: [
    /* @__PURE__ */ jsx(
      "rect",
      {
        x: "64",
        y: "888",
        width: "896",
        height: "72",
        rx: "32",
        fill: "black",
        fillOpacity: "0.65"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: "0.25",
        d: "M92 643.412V784C92 801.673 106.327 816 124 816H900C917.673 816 932 801.673 932 784V481.559C931.064 490.968 926.445 499.998 918.423 506.303L682.423 691.803C669.742 701.771 651.98 702.087 638.952 692.578L371.435 497.315L150.093 669.93C134.415 682.156 111.793 679.358 99.5664 663.68C94.8454 657.626 92.3644 650.537 92 643.412Z",
        fill: "#0A3A83"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: "0.25",
        d: "M92 360L92.4805 359.714C93.4573 365.357 95.7984 370.848 99.5664 375.68C111.793 391.358 134.415 394.156 150.093 381.93L371.435 209.315L638.952 404.578C651.98 414.087 669.742 413.771 682.423 403.803L918.423 218.303C926.308 212.105 930.906 203.275 931.949 194.039L932 194V474.394C931.344 467.814 928.869 461.337 924.48 455.753C912.193 440.122 889.561 437.41 873.93 449.697L659.372 618.343L391.943 423.144C378.956 413.665 361.258 413.946 348.58 423.834L105.816 613.153C97.2359 619.845 92.5134 629.649 92 639.725V360Z",
        fill: "#5CBAEB"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M348.579 423.834C361.257 413.947 378.955 413.665 391.942 423.144L659.371 618.343L873.929 449.697C889.56 437.41 912.193 440.122 924.479 455.753C936.766 471.385 934.054 494.017 918.423 506.303L682.423 691.803C669.742 701.771 651.979 702.087 638.951 692.578L371.435 497.315L150.093 669.93C134.414 682.156 111.793 679.358 99.5659 663.68C87.3391 648.002 90.1372 625.38 105.816 613.153L348.579 423.834Z",
        fill: "#0A3A83"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M348.579 135.834C361.257 125.947 378.955 125.665 391.942 135.144L659.371 330.343L873.929 161.697C889.56 149.41 912.193 152.122 924.479 167.753C936.766 183.385 934.054 206.017 918.423 218.303L682.423 403.803C669.742 413.771 651.979 414.087 638.951 404.578L371.435 209.315L150.093 381.93C134.414 394.156 111.793 391.358 99.5659 375.68C87.3391 360.002 90.1372 337.38 105.816 325.153L348.579 135.834Z",
        fill: "#5CBAEB"
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ jsx("rect", { width: "1024", height: "1024", fill: "white" }) }) })
] });
export {
  VisualisationStackedAreaChartIcon
};
